<template>
  <div>
    <swiper class="appCarousel" :options="swiperOption" ref="mySwiper" v-if="hasItems">
      <!-- slides -->
      <swiper-slide class="appCarousel__item"
      v-if="isIn(
        '2018-09-29 10:00:00',
        '2018-09-30 23:59:59'
        )">
        <div class="appCarousel__itemBunner">
          <a href="/campaign/movie_satv">
            <img src="/static/img/lp/movie_satv/carousel_sp.png" alt="先着20名様限定！人気占い師あなたを占う占いビデオレター" class="w375">
            <img src="/static/img/lp/movie_satv/carousel_pc.png" alt="先着20名様限定！人気占い師あなたを占う占いビデオレター" class="w376">
          </a>
        </div>
      </swiper-slide>

      <swiper-slide class="appCarousel__item">
        <div class="appCarousel__itemBunner">
          <a href="/2018secondluck?top_carousel=1">
            <img src="/static/img/secoundhalf/bn_secondhalf_sp.png" alt="" class="wsp">
            <img src="/static/img/secoundhalf/bn_secondhalf_pc.png" alt="" class="wpc">
          </a>
        </div>
        </swiper-slide>
        <swiper-slide class="appCarousel__item">
          <div class="appCarousel__itemBunner">
            <a href="/movie/firstcome?top_carousel=2">
              <img src="/static/img/lp/videoletter/bn_videoletter_sp.gif" alt="" class="wsp">
              <img src="/static/img/lp/videoletter/bn_videoletter_pc.gif" alt="" class="wpc">
            </a>
          </div>
        </swiper-slide>

        <swiper-slide class="appCarousel__item"
        v-if="isIn(
          '2018-06-13 00:00:00',
          '2018-06-18 23:59:59'
          )">
          <a class="card"
          data-shadow="false"
          data-color="yellow"
          href="/lp/movie_yoshimoto">
          <h3>占いビデオレター✕占い芸人</h3>
          <div class="media" data-align="top">
            <div class="media__image">
              <img class="counselorAvatar" width="96" height="96" src="/static/img/lp/movie_yoshimoto/yoshimoto_icon.png">
            </div>
            <div class="media__content">
              <div class="description">
                <div class="media__meta" style="margin: 17px 0;">
                  <span class="badge" data-color="white" style="margin-right: 1em">無料</span>
                  <span class="badge" data-color="white" style="margin-right: 1em">期間限定</span>
                </div>
                <p>
                  <strong>占い芸人育成プロジェクト</strong><br>
                  <span>占い研修中のよしもと芸人が、あなたを無料でリアル鑑定！</span>
                </p>
              </div>
            </div>
          </div>
        </a>
      </swiper-slide>

      <swiper-slide class="appCarousel__item" v-for="(item,index) in items" :key="item.items_id"
      v-show="!item.not_view"
      >
        <a class="card"
          data-shadow="false"
          :href="itemsLink(item,index)"
          @click="sendEvent(item)">
          <h3>{{ item.item_name }}</h3>
          <div class="media" data-align
          ="top">
          <div class="media__image">
            <img class="counselorAvatar" width="96" height="96" :src="item.counselor_image_url">
          </div>
          <div class="media__content">
            <div class="description">
              <div class="media__meta">
                <uranai-img data-clip-path-support="true" data-size="sm" size="sm" :src="item.pack_image"></uranai-img>
                <div v-if="!item.price" class="badge leftspace" data-color="white">
                  <span>無料</span>
                </div>
              </div>
              <div class="textarea">
                <p class="textarea_name u-tx-bold">{{ item.counselor_name }}</p>
                <span v-html="textSlice(item)"></span>
              </div>
            </div>
          </div>
        </div>
      </a>
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</div>
</template>


<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'app-carousel',
  components: { swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 16,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        centeredSlides: true,
        loop : true,
        speed:1200,
      }
    }
  },
  props: {
    items: {
      type: Array,
      default: []
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    hasItems() {
      // not_viewがfalsyな項目が一件でもあればtrue
      return this.items.filter(item => !item.not_view).length > 0
    }
  },
  methods: {
    /**
    * 公開期間指定用
    * @param {String} _start - YYYY-MM-DD HH:mm:ss 公開開始日時
    * @param {String} _end - YYYY-MM-DD HH:mm:ss 公開終了日時
    * @return {Boolean}
    **/
    isIn(_start = '', _end = '') {
      const start = moment(_start)
      const end = moment(_end)
      if (!start.isValid() || !end.isValid()) {
        console.warn('日時の指定が正しくありません')
        return true
      }
      return moment().isBetween(_start, _end)
    },
    sendEvent(item) {
      window.gtag('event', 'SliderText', {
        cpno: window.Laravel.cpno,
        items_id: item.items_id
      })
    },
    itemsLink(item,index) {
      return `/contents/${('000000' + item.items_id).slice(-6)}?top_carousel=${index+3}`
    },
    counselorAvatar(item) {
      const strId = sprintf('%03d', item.counselor_id)
      return `/static/img/${strId}/${strId}.png`
    },
    textSlice(item = {}) {
      const txt = item.easy_explanation
      if (!txt) {
        return ''
      }
      const length = txt.length
      const width = window.outerWidth
      const dots = '...'
      let slice = 0
      if(width <= 320) {
        slice = 24
      } else if (width <= 375) {
        slice = 30
      } else {
        slice = 30
      }
      if (length > slice) {
        return txt.substr(0, slice - 1) + '...'
      } else {
        return txt
      }
    }
  }
}
</script>
<style lang="scss">
.appCarousel {
  background: #f8f8f8;
  padding: 32px 16px;
  &__item {
    height: 160px;
    .wsp {display: none;}
    .wpc {display: block;}
    h3 {
      font-size: 14px;
      font-weight: 700;
      margin: 0 0 .5em;
      color: #4F4F4F;
      line-height: 15px;
      min-height: 31px;
    }
    &Bunner{
      height: 160px;
      border-radius: 6px;
      overflow: hidden;
      a {
        display:block;
      }
      img {
        width: 100%;
        vertical-align: top;
      }
    }
    .card {
      height: 160px;
      padding: 11px 16px;
    }
  }
  .media {
    overflow: hidden;
    height: 100px;

    &__image {
      flex: 0 0 96px;
      margin: auto 0;
      margin-right: 16px;
    }
    &__meta {
      display: flex;
      align-items: center;
    }
    &__content {
      .description {
        font-size: 11px;
        p {
          margin: 0;
        }

        .textarea {
          width: 166px;

          &_name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .card {
    &[data-color="yellow"] {
      background: #F7EF00;
    }
  }
}

.counselorAvatar {
  border-radius: 50%;
  object-fit: cover;
  width: 96px;
  height: 96px;
  display: block;
}

@media screen and (max-width: 360px) {
  .appCarousel__item {
    width: 260px;
    .wsp {display: block;}
    .wpc {display: none;}
  }
  .appCarousel__item .card {
    padding: 10px;
  }
  .appCarousel {
    .media {
      &__image {
        margin-right: 8px;
      }
      .description {
        .textarea {
          width: 136px;
        }
      }
    }
  }
}

@media screen and (min-width: 320px) {
  .appCarousel {
    &__item {
      width: 260px;
    }
  }
}
@media screen and (min-width: 375px) {
  .appCarousel__item {
    width: 310px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/AppCarousel.vue